<!-- Begin: Admin Form -->

<div class="admin-form">

  <div class="panel heading-border">
      <div class="panel-body bg-light">
          <form ngNativeValidate [formGroup]="forma" (ngSubmit)="editItem()" method="post" id="form-ui">
              <div class="section-divider mb40" id="spy1">
                  <span>Register Car</span>
              </div>
              <!-- .section-divider -->

              <!-- Basic Inputs -->
              <div class="row">

                  <div class="col-md-12">
                      <div class="row ">
                          <div class="col-md-6 ">
                              <div class="section ">


                                  <mat-form-field class="example-full-width">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" name="code" id="model" >
                                    <mat-icon matSuffix>
                                      qr_code
                                    </mat-icon>
                                  </mat-form-field>


                              </div>
                          </div>
                          <div class="col-md-6 ">
                              <div class="section ">


                                <mat-form-field class="example-full-width">
                                  <mat-label>Name</mat-label>
                                  <input matInput formControlName="name" name="name" id="name" >
                                  <mat-icon matSuffix>
                                     label
                                  </mat-icon>
                                </mat-form-field>

                              </div>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12">
                              <div class="section ">


                                <mat-form-field class="example-full-width">
                                  <mat-label>Description</mat-label>
                                  <input matInput formControlName="description" name="description" id="description" >
                                  <mat-icon matSuffix>
                                    line_weight
                                  </mat-icon>
                                </mat-form-field>


                              </div>
                          </div>

                      </div>



                      <div class="row">
                        <div class="col-md-6">


                          <mat-form-field class="example-full-width">
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="status">

                                 <mat-option value="0">Inactive </mat-option>
                                <mat-option value="1">Active  </mat-option>
                            </mat-select>

                            <mat-error *ngIf="forma.controls.status.hasError('required')">You must make a selection</mat-error>
                          </mat-form-field>

                        </div>
                      </div>





                  </div>
              </div>





              <div class="panel-footer text-center ">
                  <button type="submit" [disabled]="!forma.valid" class="button btn-primary" style="margin-top: 10px;">Save</button>
              </div>
              <!-- end .form-footer section -->
          </form>
      </div>
  </div>

</div>
